export default __webpack_public_path__ + "static/media/tr.17b61cd9.svg";